define('lq/videoPlayer',[
    'jquery',
    'underscore',
    'lq'
], function ($, _, lq) {
    'use strict';

    var supportedTypes = [
        'webm',
        'mp4',
        'ogg'
    ];

    var datasetup = [
        // 'flash',
        'html5',
        'youtube'
    ];

    function VideoPlayer($element) {
        this.$element = $element;
        this.player = null;
    }

    VideoPlayer.prototype.open = function(config) {
        this.close();

        if(!config.url)
            return;

        require([
            'videojs.youtube'
        ], this.videoLoaded.bind(this, config));
    };

    VideoPlayer.prototype.videoLoaded = function (config, video) {
        var videoType = config.videoType || this.getVideoType(config.url);
        if (!videoType)
            return;

        var $source = $('<source />')
            .attr('type', 'video/' + this.videoType)
            .attr('src', config.url);

        var id = _.uniqueId('v');
        var $video = $('<video />')
             .attr('id', id)
             .attr('class', 'video-js vjs-default-skin vjs-big-play-centered')
             .attr('width', this.$element.width())
             .attr('height', this.$element.height())
             .attr('data-height', '264')
             .attr('controls', 'false')
             .attr('poster', config.poster)
             .attr('preload', 'auto')
             .attr('autoplay', config.autoPlay)
             .attr('loop', config.loop)
             .attr('controls', config.controls)
             .attr('videoType', videoType)
            .append($source);

        if (config.autoPlay) {
            $video.attr('muted', '')
                .attr('playsinline', '');
        }

        this.$element.append($video);

        this.player = video($video.get(0), {
            techOrder: datasetup,
            preload: 'auto',
            autoplay: config.autoPlay,
            loop: config.loop,
            controls: config.controls,
            poster: [config.poster],
            sources: [
                {
                    type: 'video/' + videoType,
                    src: config.url
                }
            ]
        });

        this.player.on('error', this.showAsError.bind(this));

        if (config.autoPlay) {
            video(id).ready(function () {
                this.play();
            });
        }

        if (config.onEnded)
            this.player.on('ended', config.onEnded);
    };

    VideoPlayer.prototype.close = function() {
        if(this.player) {
            this.player.dispose();
            this.player = null;
        }
    };

    VideoPlayer.prototype.hasVideo = function () {
        return this.player !== null;
    };

    VideoPlayer.prototype.getVideoType = function(url) {
        var extension = url.split('.').pop();

        var i = supportedTypes.indexOf(extension);
        if (i !== -1)
            return extension;

        if (extension === 'ogv') {
            return 'ogg';
        }

        var match = url.match(/v=([^&]+)/);
        if (match != null && match.length == 2)
            return 'youtube';

        return null;
    };

    VideoPlayer.prototype.showAsError = function () {
        $('<div />')
            .text('The video cannot be player')
            .appendTo(this.$element)
            .css({
                backgroundColor: 'black',
                position: 'absolute',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            })
            .append($('<span />')
           .text('The video cannot be played')
           .css({
               color: 'white',
               position: 'absolute',
               top: '50%',
               left: '50%',
               transform: 'translate(-50%, -50%)'
           }));
    };

    return VideoPlayer;
});
